import { useCallback, useEffect, useState } from 'react';
import { usePreviousValue } from '../../../hooks/usePreviousValue';
import { ICalendarDate } from '../Calendar';
import { ICalendarViewState } from '../View/CalendarView';
import { calcYearAndMonth, isTwoViewsEqual } from '../helpers/dateFormatters';
export const useDoubleCalendar = (selectedDateOne, selectedDateTwo) => {
  let initialState;
  if (selectedDateOne.year === selectedDateTwo.year && selectedDateOne.monthIndex === selectedDateTwo.monthIndex) {
    initialState = {
      viewStateOne: {
        year: selectedDateOne.year,
        monthIndex: selectedDateOne.monthIndex
      },
      viewStateTwo: calcYearAndMonth({
        ...selectedDateOne,
        changeMonths: 1
      })
    };
  } else {
    initialState = {
      viewStateOne: {
        year: selectedDateOne.year,
        monthIndex: selectedDateOne.monthIndex
      },
      viewStateTwo: {
        year: selectedDateTwo.year,
        monthIndex: selectedDateTwo.monthIndex
      }
    };
  }
  const [doubleViewState, setDoubleViewState] = useState(initialState);
  const prevDoubleViewState = usePreviousValue(doubleViewState);
  const handleIncrementMonthIndexOne = useCallback(viewStateOne => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateOne
      };
    });
  }, []);
  const handleIncrementMonthIndexTwo = useCallback(viewStateTwo => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateTwo
      };
    });
  }, []);
  const handleDecrementMonthIndexOne = useCallback(viewStateOne => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateOne
      };
    });
  }, []);
  const handleDecrementMonthIndexTwo = useCallback(viewStateTwo => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateTwo
      };
    });
  }, []);
  const handleChangeViewYearOne = useCallback(viewYearOne => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateOne: {
          monthIndex: prev.viewStateOne.monthIndex,
          year: viewYearOne
        }
      };
    });
  }, []);
  const handleChangeViewYearTwo = useCallback(viewYearTwo => {
    setDoubleViewState(prev => {
      return {
        ...prev,
        viewStateTwo: {
          monthIndex: prev.viewStateTwo.monthIndex,
          year: viewYearTwo
        }
      };
    });
  }, []);
  useEffect(() => {
    if (prevDoubleViewState) {
      const hasViewOneChanged = !isTwoViewsEqual(prevDoubleViewState.viewStateOne, doubleViewState.viewStateOne);
      const changedView = hasViewOneChanged ? 'viewStateOne' : 'viewStateTwo';
      const affectedView = hasViewOneChanged ? 'viewStateTwo' : 'viewStateOne';
      if (doubleViewState.viewStateOne.year > doubleViewState.viewStateTwo.year) {
        setDoubleViewState(prev => ({
          ...prev,
          [affectedView]: calcYearAndMonth({
            ...prev[changedView],
            changeMonths: changedView === 'viewStateOne' ? 1 : -1
          })
        }));
      }
      if (doubleViewState.viewStateOne.year === doubleViewState.viewStateTwo.year && doubleViewState.viewStateOne.monthIndex === doubleViewState.viewStateTwo.monthIndex) {
        setDoubleViewState(prev => ({
          ...prev,
          [affectedView]: calcYearAndMonth({
            ...prev[affectedView],
            changeMonths: changedView === 'viewStateOne' ? 1 : -1
          })
        }));
      }
    }
  }, [doubleViewState, prevDoubleViewState]);
  return {
    handleChangeViewYearOne,
    handleChangeViewYearTwo,
    handleIncrementMonthIndexOne,
    handleIncrementMonthIndexTwo,
    handleDecrementMonthIndexOne,
    handleDecrementMonthIndexTwo,
    setDoubleViewState,
    currentViewStateOne: doubleViewState.viewStateOne,
    currentViewStateTwo: doubleViewState.viewStateTwo
  };
};